import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getPoliciesData, getHeaderNotification, getFaqsData} from '../../utils/endpoints'
import InnerContent from '../components/innerContent';
import { Container } from 'react-bootstrap';
import Loading from '../components/loading';
import HeaderNotification from '../components/headerNotification';
import Faqs from '../components/faq';
import Header from '../components/header';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet';

const PoliciesDetails = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [policiesData, setPoliciesData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const policiesData = await getPoliciesData(id);
            setPoliciesData(policiesData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>{policiesData[0]?.title?.rendered} || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
        <Container>
        <ul>
                <li><a href="/">Home</a></li>
                <li dangerouslySetInnerHTML={{ __html: policiesData[0]?.title?.rendered }}></li>
            </ul>
            <h1 dangerouslySetInnerHTML={{ __html: policiesData[0]?.title?.rendered }}></h1>
        </Container>
        </section>
      <Container>
        <div className={'mt-5'}>
        <InnerContent compData={policiesData}/>
        </div>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default PoliciesDetails;